<div class="show-onhover">
  <img src="/assets/images/icons/edit_green.svg" class="edit-icon" (click)="edit(editTeamMemberModal, effectiveParams.data)" />
</div>

<ng-template #editTeamMemberModal let-modal>
  <div class="modal-header">
    <div class="modal-title">Edit Team Member</div>
    <img class="close-modal-image" src="/assets/images/close-static.svg" (click)="modal.dismiss()" />
  </div>

  <div *ngIf="!updateSent">
    <div class="modal-intro">
      You have selected to change team member slot {{ modalModel.id }}. You can use this option to edit details or give an unused slot to a different
      person.
    </div>

    <form #f="ngForm" (ngSubmit)="submitForm(f)">
      <div class="modal-body">
        <div class="container">
          <div class="form-group">
            <label for="firstName">FIRST NAME</label>
            <input
              type="text"
              placeholder="First Name"
              required
              [(ngModel)]="modalModel.firstName"
              name="firstName"
              #firstName="ngModel"
              class="form-control"
            />

            <label for="lastName">LAST NAME</label>
            <input
              type="text"
              placeholder="Last Name"
              required
              [(ngModel)]="modalModel.lastName"
              name="lastName"
              #lastName="ngModel"
              class="form-control"
            />

            <label for="emailAddress">EMAIL</label>
            <input
              type="email"
              placeholder="Email"
              required
              [(ngModel)]="modalModel.emailAddress"
              name="emailAddress"
              #emailAddress="ngModel"
              class="form-control"
              pattern="^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[a-z]{2,4}$"
              [class.is-invalid]="emailAddress.invalid && emailAddress.touched"
              [readonly]="modalModel.status !== 'Not Started'"
            />

            <div class="cannot-edit">
              <span *ngIf="modalModel.status === 'In Progress'"><i>Note:</i> You cannot edit the email address of a team member in progress.</span>
              <span *ngIf="modalModel.status === 'Completed'"
                ><i>Note:</i> You cannot edit the email address of a team member who has completed their assessment.</span
              >
            </div>

            <input type="hidden" [(ngModel)]="modalModel.teamMemberId" name="teamMemberId" #teamMemberId="ngModel" />
            <input type="hidden" [(ngModel)]="modalModel.id" name="id" #id="ngModel" />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn-primary" [disabled]="!f.valid">Save</button>
        <a (click)="modal.dismiss()">Cancel</a>
      </div>
    </form>
  </div>
  <div *ngIf="updateSent" class="modal-body pad-bottom">
    <div [hidden]="hideUpdateSpinner" class="spinner-container pad-bottom">
      <div class="d-flex justify-content-center">
        <div class="spinner-border custom-spinner" role="status">
          <span class="visually-hidden">Updating Team Member...</span>
        </div>
      </div>
    </div>
    <div [hidden]="!hideUpdateSpinner" class="pad-bottom">
      {{ updateResponse }}
    </div>
    <button class="btn-primary" (click)="modal.dismiss()">Close</button>
  </div>
</ng-template>
